module.exports = __webpack_public_path__ + "img/racetrack-fairview-poly.6c781423.svg";